import { render, staticRenderFns } from "./MainNav.vue?vue&type=template&id=2a822b29&scoped=true&"
import script from "./MainNav.vue?vue&type=script&lang=js&"
export * from "./MainNav.vue?vue&type=script&lang=js&"
import style0 from "./MainNav.vue?vue&type=style&index=0&id=2a822b29&prod&lang=scss&"
import style1 from "./MainNav.vue?vue&type=style&index=1&id=2a822b29&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a822b29",
  null
  
)

export default component.exports